<template>
  <el-dialog title="Apply for Job Role" :visible="showModal" :show-close="false" width="580px" class="ts-modal">
    <p>
      By applying for this role posted by {{matchInfo.companyName}}, 
      you are agreeing to your contact details to be visible so that the company
      may contact you in regards to the role and interview process.
    </p>
    &nbsp;&nbsp;
    <el-row :gutter="10">
      <el-col :offset="6" :xl="6" :lg="6" :md="6">
        <button class="ts-btn ts-btn-small" @click="confirmApplyForRole">Apply for Role</button>
      </el-col>
      <el-col :xl="5" :lg="5" :md="5">
        <button class="ts-btn ts-btn-small ts-btn-white" @click="onCloseDialog(null)">Cancel</button> 
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import * as signalR from '@aspnet/signalr';

export default {  
  created(){
      this.matchInfo = this.$route.params.data;

      //create signalR connection
      this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
      this.connection = new signalR.HubConnectionBuilder().withUrl(this.huburl, { 
        transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
        'content-type': 'application/json',
        accessTokenFactory: () => localStorage.getItem('token') 
      }).build();

      this.connection.start().catch(function(err){
        return console.error(err.toString());
      });
    },
  data() {
    return {
      isLoading: false,
      showModal: true,
      matchInfo: {},
      connection : "",
      huburl: ""
    };
  },
  computed: {
    currentApprentice() {
      return this.$store.state.account.current_user;
    },
  },
  methods: {
    onCloseDialog(done) {
      this.showModal = false;
      this.$router.push({ name: 'role-matching-apprentice' });
    },
    confirmApplyForRole() {

      // var request = {};
      // request.organisationId = this.matchInfo.companyId;
      // request.apprenticeId = this.currentApprentice.apprenticeId;
      // request.userId = this.currentApprentice.id;
      // request.capturedSurveyId = this.matchInfo.capturedSurveyId;
      // request.matchedPercentage = this.matchInfo.percentMatch;
      var request = {
        UserId: this.currentApprentice.id,
        ApprenticeId: this.$store.state.account.applicant_user_info.apprenticeId,
        CapturedSurveyId : this.matchInfo.employeeId,
        UpSkillingRequired : this.matchInfo.sgaUpSkills,
        MatchedPercentage : this.matchInfo.percentMatch,
        Position : this.matchInfo.position,
        OrganisationId : this.matchInfo.fullSGA.sgaEmployeeInfo.organisationId,
        Payload : JSON.stringify(this.matchInfo.fullSGA)
      };

      this.$store
        .dispatch('apprentice/sendInterestToCompany', request)
        .then((res) => {
          // this.connection.invoke("SendMessageToAdmin", "Apprentice Added").catch(function(err){
          //   return console.error(err.toString());
          // });        
          this.$message.success("Interest request has been sent to the company!"); 
          this.$router.push({ name: 'role-matching-apprentice' });
        });
    },
  }
};
</script>